import { combineReducers } from '@reduxjs/toolkit';
import authReducers from './authReducers';
import settingsReducers from './settingsReducers';
import colorReducers from './colorReducers';
import paginationReducers from './paginationReducers';
import userReducers from './userReducers';

// Combine all reducers
const appReducer = combineReducers({
  auth: authReducers,
  settings: settingsReducers,
  color: colorReducers,
  pagination: paginationReducers,
  user: userReducers
});

// Root reducer with reset functionality
const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    state = undefined; // Reset entire Redux store
  }
  return appReducer(state, action);
};

export default rootReducer;
